
import { IMRDXDashboardFilterController } from "./dxdashboard-filter.controller"
import { DXDASHBOARD_SERVICE_NAME } from "../../services"

import './dxdashboard-filter.scss'
import * as TEMPLATE from './dxdashboard-filter.tpl.html'

export const COMPONENT_NAME: string = 'imrDxdashboardFilter'

export class IMRDXDashboardFilterComponent implements ng.IComponentOptions {

    controller = [DXDASHBOARD_SERVICE_NAME, IMRDXDashboardFilterController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}
